<template>
    <main class="app-get-step" id="mainContent">
        <div class="app-main-content">
            <div class="insuranceShowError app-alert-error app-system-alert" v-if="insuranceShowErrorMessage">
                <p>To continue with your registration transaction you must certify that you are authorized to cancel the registration.
                    Please review your response below.
                </p>
            </div>
            <h1>Cancel Registration confirmation</h1>
            <div class="app-content-panels">
                <div class="app-panel-left">
                    <div>
                        <p>
                            By checking "Yes" below, , I certify that I am the registered owner of the vehicle or I am authorized by the registered owner to cancel its registration.
                            I confirm that I want to cancel the registration for the below mentioned plate number and understand that <strong>ALL REGISTRATION CANCELLATIONS ARE FINAL.</strong>
                        </p>
                        <p>
                            <strong> {{ year }} {{ make }} {{ model !='UNKNOWN' ? model : '' }} {{ plateNumber }} / {{ plateType }} </strong>
                        </p>
                        <div class="app-input-group">
                            <div class="app-input-selector"><input type="radio" id="yes" name="notify" v-model="insuranceInfo" value="yes" @change="insuranceError=false; insuranceShowErrorMessage=false">
                                <label for="yes">Yes</label>  
                            </div>
                            <div class="app-input-selector"><input type="radio" id="no" name="notify-no" v-model="insuranceInfo" value="no" @change="insuranceError=false"> 
                                <label for="no">No</label> 
                            </div>
                        </div>
                    </div>
                    <p class="app-error-message" v-if="insuranceError"> Response to this question is required. </p>
                    <p id="app-error-message" class="sr-only" v-if="insuranceError"> Response to this question is required. </p>
                    <BaseButtonGroup>
                        <!-- <button type="button" @click="handleRouting(true)">Previous</button>
                        <button type="button" class="app-btn-primary"
                            @click="handleRouting(false)">Next
                        </button>
                        <button type="button" v-if="!disableBtn" @click="getGoToProfile()">Cancel and go to profile</button>
                        <button type="button" :class="{ 'disabled': !disableBtn }" :aria-disabled="!disableBtn" @click="goToTxnCart(true)" v-if="disableBtn">
                            Cancel and go to cart
                        </button> -->

                        <CustomButton @click="handleRouting(true)" class="resend-code">Previous</CustomButton>
                        <CustomButton @click="handleRouting(false)">Next</CustomButton>
                        <CustomButton v-if="!disableBtn" @click="getGoToProfile()" class="resend-code">Cancel and go to profile</CustomButton>
                        <CustomButton :class="{ 'disabled': !disableBtn }" :aria-disabled="!disableBtn" @click="goToTxnCart(true)" v-if="disableBtn" class="resend-code">
                            Cancel and go to cart
                        </CustomButton>
                    </BaseButtonGroup>
                </div>
            </div>
        </div>
    </main>
</template>
    
<script>
import appConfig from '@/app.config';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import { mapState, mapActions } from 'vuex';
import * as COMMONS from '../../store/_commons';
import CustomButton from '../../components/CustomButton.vue';
  
export default {
    name: 'TransactionInformation',
    page: {
      title: `Transaction Information | ${appConfig.shortName}`,
      meta: [
        {
          name: 'description',
          content: 'You can renew your vehicle registrations'
        }
      ]
    },

    data() {
      return {
        stepNum: 2,
        screenData: {},
        enableNext: true,
        showError: false,
        showModalActive: false,
        insuranceInfo: '',
        insuranceShowErrorMessage: false,
        insuranceError: false,


        year:  this.$store.state.guestLogin.selectRenewRegistartion.year,
        make: this.$store.state.guestLogin.selectRenewRegistartion.make,
        model: this.$store.state.guestLogin.selectRenewRegistartion.model,
        plateNumber: this.$store.state.guestLogin.selectRenewRegistartion.plateNumber,
        plateType: this.$store.state.guestLogin.selectRenewRegistartion.plateType,
      }
    },

    components: {
        BaseButtonGroup,
        CustomButton
    },

    computed: {
        ...mapState([
            'LANG',
            'STEPS',
        ]),
        language() {
            return this.LANG;
        },

        disableBtn() {
            let btn = false;
            if(this.$store.state.guestLogin.cartTransactions){
                btn = this.$store.state.guestLogin.cartTransactions.cartTransactions.length > 1
            }
            return btn;
        }
    },

    created() {
        this.screenData = this.STEPS[this.stepNum]; 
        document.body.setAttribute("tabindex", "1");
        document.body.focus();
        document.body.removeAttribute("tabindex");
    },

    methods: {
        ...mapActions({
            getSaveWipData: COMMONS.GUEST_SAVEWIPDATA,
            getCancelTransaction: COMMONS.GUEST_CANCELTRANSACTION, 
        }),

        async handleRouting(isPrev = false) {
            if (isPrev) {
                await this.getCancelTransaction().then(()=> {
                    this.$emit('getStep' , 1);
                    this.$store.state.guestLogin.step = 1;
                })
            } 
            else {
                // do nothing if [Next] is not enabled (use aria-disabled for better accessibility)
                if (this.insuranceInfo == 'yes') {
                    await this.getSaveWipData().then((result) =>{
                        console.log(result)
                    });
                }
                else if (this.insuranceInfo == 'no') {
                    this.insuranceShowErrorMessage = true;
                }
                else{
                    this.insuranceError = true;
                }
            }
        },

        async goToTxnCart() {
            await this.getCancelTransaction().then(() => {
                this.$emit('getStep' , 4);
                this.$store.state.guestLogin.step = 4;
            });
        },

        async getGoToProfile() {
            await this.getCancelTransaction().then( () => {
                this.$router.push({name: 'Profile'});
            }) 
        },

        getShowModalActive() {
            this.showModalActive = false;
            document.getElementById("mainContent").setAttribute("tabindex", "1");
            document.getElementById("mainContent").focus();

            document.getElementById("mainContent").removeAttribute("tabindex");
            document.getElementById("mainContent").scrollTop = 0;
        },

        showRenewRegModal(val) {
            this.activeModal = false;
            if(val == 'Yes') {
                this.getCancelTransaction().then( () => {
                    this.$store.state.guestLogin.step = 4;
                }) 
            }
        },
    },

    mounted() {
        window.scroll(0,0);

        document.getElementById("mainContent").focus();
    }
    
}
</script>

<style scoped lang="scss">
    .app-alert-error {
        display: block;
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 18px;
        line-height: 28px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .app-input-group {
        display: flex;
        margin-top: 0.5rem;
        gap: 2rem;
        .input-radio {
            min-width: 100px;
            input[type="radio"] {
            margin: 0.5em 0;
            }
        }
        label {
            margin-top: 0.65em;
        }
    }

    .app-modal-basic {
        overflow-y: auto;
        height: 300px;
    }

    .app-error-message {
        color: var(--ri-red);
        @extend %font-sans-regular;
        line-height: 1.35em;
        margin: unset;
        padding: 0.5em 0;
        &.--checker {
            margin-left: 1.5em;
        }
    } 
    .insuranceShowError >>> p {
        font-size: 1rem;
        line-height: 1.5em;
        padding-top: .5em;
        padding-bottom: .5em;
    }
    .resend-code{
        background-color: white;
        color: var(--ri-blue);

        &:hover{
            background-color: var(--ri-lighter-blue);
            color: var(--ri-darker-blue);
        }
    } 
</style>
